import { registerGraph } from '@/angular/modules/vrm-graph/config-utils';

registerGraph('highchartsOptions', highchartsOptions);

/* @ngInject */
function highchartsOptions(GraphService, locale) {
    const GraphColors = GraphService.colors;
    return {
        colors: [GraphColors.red, GraphColors.blue, GraphColors.orange, GraphColors.green],
        chart: {
            backgroundColor: null,
            plotBackgroundColor: null,
            plotShadow: false,
            selectionMarkerFill: "rgba(80,80,80,0.25)"
        },

        yAxis: {
            labels: {
                style: {
                    color: '#959490',
                    fontFamily: "museo-sans"
                }
            }
        },

        xAxis: {
            lineColor: "#63625e",
            labels: {
                style: {
                    color: '#959490',
                    fontFamily: "museo-sans"
                }
            }
        },

        title: {
            style: {
                fontFamily: "museo-sans",
                fontSize: "27px"
            }
        },

        tooltip: {
            shadow: false,
            borderWidth: 0,
            style: {
                color: '#FFF',
                display: 'none' // Don't show svg background
            }
        },

        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                hoverSymbolStroke: '#FFFFFF',
                theme: {
                    fill: {
                        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                        stops: [
                            [0.4, '#606060'],
                            [0.6, '#333333']
                        ]
                    },
                    stroke: '#000000'
                }
            }
        },

        lang: {
            shortMonths: [
                locale.getString('graph.short_january'),
                locale.getString('graph.short_februari'),
                locale.getString('graph.short_march'),
                locale.getString('graph.short_april'),
                locale.getString('graph.short_may'),
                locale.getString('graph.short_juni'),
                locale.getString('graph.short_july'),
                locale.getString('graph.short_august'),
                locale.getString('graph.short_september'),
                locale.getString('graph.short_october'),
                locale.getString('graph.short_november'),
                locale.getString('graph.short_december')
            ],

            loading: locale.getString('graph.loading'),
            resetZoom: locale.getString('graph.reset_zoom'),
            noData: locale.getString('graph.no_data')
        }
    };
}
